module.exports = __webpack_public_path__ + "static/media/1006666.90c2bbac.jpg";